module.exports = __webpack_public_path__ + "img/3ad4752.jpg";